import { useTranslation } from 'react-i18next';
import type { SettingType } from '@/types/app';
import SummaryCard from '../SummaryCard';
import Wages from './WagesSummary';

interface SummaryProps {
	loading: boolean;
	handleSettingClick: (setting: SettingType) => void;
	activeSetting: SettingType | null;
	employeesSource: string | null;
	idx: number;
	isConfirmed?: boolean;
}

const Summary = ({
	loading,
	handleSettingClick,
	activeSetting,
	employeesSource,
	idx,
	isConfirmed = false
}: SummaryProps) => {
	const { t } = useTranslation();

	return (
		<SummaryCard
			type="employees"
			title={t('quotes.settings.employees.title')}
			onClick={handleSettingClick}
			isActive={activeSetting === 'employees'}
			source={employeesSource}
			loading={loading}
			idx={idx}
			isConfirmed={isConfirmed}
		>
			<Wages loading={loading} />
		</SummaryCard>
	);
};

export default Summary;
